import './js/refs';
import './js/loader';
import './js/fetch';
import './js/button-scroll-to-top';
import './js/modal';
import './js/team-modal';
import './js/auth';
import './js/pagination';
import './js/render-card-markup';
import './js/search-film';
import './js/you-tube';
import './js/darktheme';



